import { AxiosResponse } from 'axios';
import { KeyValue } from '@/main/models/common';
import { StateFilterRequest, StatesFilterRequest } from '@/main/models/request';
import { Result } from '@/main/models/common/resultResponse';

export abstract class IStateApi {
  abstract getDomain(request:StateFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
  abstract getDomainPublic(request:StateFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
  abstract getDomainByBodyshop(request:StatesFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
